module.exports = __webpack_public_path__ + "img/services-img5.14892bd0.jpg";